import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { costCentersStateSelector } from '~/selectors';

import { CostCenter } from './types';

export const useAllCostCenters = (): {
  costCenters: CostCenter[];
  getCostCenterById: (costCenterId: number) => CostCenter | undefined;
  hasData: boolean;
  isLoading: boolean;
  failedToLoad: boolean;
} => {
  const { costCenters, ...rest } = useSelector((state: StoreState) => {
    return costCentersStateSelector(state);
  });

  const getCostCenterById = useCallback(
    (costCenterId: number) => {
      return costCenters.find((cc) => cc.fCostCenterId === costCenterId);
    },
    [costCenters],
  );

  return {
    costCenters,
    getCostCenterById,
    ...rest,
  };
};
